namespace AgerLMS.LMS {
    export interface LmsCategoryRow {
        CategoryId?: number;
        CategoryName?: string;
        CategoryType?: CategoryTypes;
        ParentCategoryId?: number;
        Icon25x25?: string;
        CoverImage?: string;
        Description?: string;
        Seo?: string;
        DisplayOrder?: number;
        ParentCategoryCategoryName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace LmsCategoryRow {
        export const idProperty = 'CategoryId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'CategoryName';
        export const localTextPrefix = 'LMS.LmsCategory';
        export const lookupKey = 'LMS.Category';

        export function getLookup(): Q.Lookup<LmsCategoryRow> {
            return Q.getLookup<LmsCategoryRow>('LMS.Category');
        }
        export const deletePermission = 'LMS:LmsCategory:Modify';
        export const insertPermission = 'LMS:LmsCategory:Modify';
        export const readPermission = 'LMS:LmsCategory:Read';
        export const updatePermission = 'LMS:LmsCategory:Modify';

        export declare const enum Fields {
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            CategoryType = "CategoryType",
            ParentCategoryId = "ParentCategoryId",
            Icon25x25 = "Icon25x25",
            CoverImage = "CoverImage",
            Description = "Description",
            Seo = "Seo",
            DisplayOrder = "DisplayOrder",
            ParentCategoryCategoryName = "ParentCategoryCategoryName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
